const modelMaterials = {
  wood: {
    Spruce: "SPRUCE-diffuse.png",
    Larch: "LARCH-diffuse.png",
    Oak: "OAK-diffuse.png",
    Thermowood: "THERMWOOD-diffuse.png",
    "Red Cedar": "RED-CEDAR-diffuse.png",
  },
  linerColor: {
    Blue: "polypropalyne-blue.png",
    Grey: "polypropalyne-grey.png",
    White: "polypropalyne-white.png"
  },
};

export default modelMaterials;